import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TableOption } from 'src/app/invopay/interfaces/Iip-table-options';
import { IpRoleService } from 'src/app/invopay/services/ip-role.service';
import { FnPaymentDetailsComponent } from '../fn-payment-details/fn-payment-details.component';
import { TableEvent } from 'src/app/shared/components/table/Itable';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentConsolidate, FnConsolidatedService } from '../../services/fn-consoldate.service';
import { Observable, Subject } from 'rxjs';
import { FnStatusModalComponent } from '../fn-status-modal/fn-status-modal.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-fn-consolidated-details',
  templateUrl: './fn-consolidated-details.component.html',
  styleUrls: ['./fn-consolidated-details.component.scss'],
})
export class FnConsolidatedDetailsComponent implements OnInit {
  type!: 'business' | 'employee' | 'provider';
  tableOptions!: TableOption;
  propertyOrder: string[] = [];
  consolidatedDetails?: any;
  dataOk = false
  private dataChangeSubject: Subject<void> = new Subject<void>();
  dataChange: Observable<void> = this.dataChangeSubject.asObservable();
  currentConsolidate!: CurrentConsolidate;

  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private roleService: IpRoleService,
    private consolidatedService: FnConsolidatedService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.currentConsolidate = this.consolidatedService.currentConsolidate;
    this.type = this.roleService.getType();
    this.propertyOrder = this.setProperty();

    this.tableOptions = {
      keyTranslate: this.setKeyTranslate(),
      selects: [],
      actions: this.setActions(),
      filters: this.setFilters(),
    };
  }

  setKeyTranslate(): string {
    return 'IP.TABLE.CONSOLIDATED-DETAIL';
  }

  setFilters(): Array<[string, string]> {
    switch (this.type) {
      case 'business':
      case 'provider':
        return [['IP.TABLE.DASHBOARD.FILTER.DATE-ISSUED', 'date']];
      default:
        return [];
    }
  }

  setProperty(): string[] {
    switch (this.type) {
      case 'business':
        return [
          'broker_name',
          'cuit',
          'bank',
          'branch_number',
          'owner_name',
          'id_consolidated',
          'invoices_total',
          'amount',
          'is_paid'
        ];
      default:
        return [];
    }
  }

  setActions(): Array<string> {
    switch (this.type) {
      case 'business':
        return ['search', 'status'];
      default:
        return [];
    }
  }

  async onAction(tableEvent: TableEvent) {
    switch (tableEvent.event) {
      case 'search':
        const { width, minWidth } = this.getDialogDimensions();
        const dialogRef = this.dialog.open(FnPaymentDetailsComponent, {
          height: 'max-content',
          width: width,
          minWidth: minWidth,
          panelClass: 'custom-modal',
          data: {
            isConsolidatedEdited: false,
            info: tableEvent.dataField,
          },
        });
        dialogRef.afterClosed().subscribe(()=> {
          //this.dataChangeSubject.next();
      })
        dialogRef.disableClose = true;
        break;
      case 'status':
        const dialogRefStatus = this.dialog.open(FnStatusModalComponent, {
          width: '400px',
          height: 'max-content',
          data: {
            consolidated: tableEvent.dataField,
            type: 'consolidatedItem'
          },
        });

        dialogRefStatus.afterClosed().subscribe({
          next: (resp) => {
            if (resp){
              this.currentConsolidate.modifiedBy = sessionStorage.getItem('username')!;
              this.currentConsolidate.lastModificationDate = this.formatDate(new Date().toString())
              this.dataChangeSubject.next();
            }
            
          },
        });
        break;
      default:
        break;
    }
  }

  private getDialogDimensions() {
    if (this.breakpointObserver.isMatched(Breakpoints.Web)) {
      return { width: 'max-content', minWidth: '50%' };
    } else {
      return { width: 'max-content', minWidth: '80%' };
    }
  }

  downloadCsv(){
    this.route.paramMap.subscribe((params) => {
      const consoId = Number(params.get('consolidatedId'));
      this.consolidatedService.getConsolidateDetails(consoId).subscribe({
        next: (response) => {
          const headersArray: string[] = ['proveedor/broker', 'Banco', 'sucursal', 'Nro_de_cuenta', 'nombre_del_titular', 'cuit','cantidad_de_facturas', 'ids_de_facturas', 'moneda', 'total'];
          let csv = headersArray.join(',')
          response.content.forEach((val: any) => {
            const row: string[] = [];
            row.push(val.businessName ?? '-')
            row.push(val.bank ?? '-')
            row.push(val.branchNumber ?? '-')
            row.push(val.accountNumber ?? '-')
            row.push(val.ownerName ?? '-')
            row.push(val.cuit ?? '-')
            row.push(val.totalInvoices ?? '-')
            row.push(val.invoicesIds ?? '-')
            row.push(val.currency ?? '-')
            row.push(val.amount ?? '-')
      
            csv = csv + "\n" + row.join(',')
          });
          const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          let link = document.createElement('a');
          let url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', 'consolidated-to-pay-file');
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);    
        }
      });
    });
  }
  
  formatDate(date: string): string {
    const day = this.datePipe.transform(date, 'dd');
    const month = this.datePipe.transform(date, 'MM');
    const year = this.datePipe.transform(date, 'yyyy');
    const time = this.datePipe.transform(date, 'H:mm:ss');
    return `${day}/${month}/${year} - ${time}`;
  }
}
